var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-check';
                    var viewUrl = 'sprite.svg#view-icon-check';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 9',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };